import { useChat } from '../../chat/useChat';
import { ChatActionContent } from './ChatActionContent';
import { isCsAvailable } from '@orthly/date-fns-business-days';
import { useScreenIsMobile } from '@orthly/ui-primitives';
import React from 'react';

interface ChatActionProps {
    orderId?: string;
    orderCanLeaveNotes?: boolean;
    setAddOrderNotesDialogOpen?: (addOrderNotesDialogOpen: boolean) => void;
    showAddOrderNotes?: boolean; // Optional prop
}

export const ChatAction: React.FC<ChatActionProps> = ({ orderId, orderCanLeaveNotes, setAddOrderNotesDialogOpen }) => {
    const { openChat } = useChat();
    const isMobile = useScreenIsMobile();

    const isWithinBusinessHours = isCsAvailable(new Date());

    const showAddOrderNotesCalculated = () => {
        if (orderId && orderCanLeaveNotes) {
            return !isWithinBusinessHours;
        } else {
            return false;
        }
    };

    return (
        <ChatActionContent
            orderId={orderId}
            isMobile={isMobile}
            setAddOrderNotesDialogOpen={setAddOrderNotesDialogOpen}
            openChat={openChat}
            showAddOrderNotes={showAddOrderNotesCalculated()}
        />
    );
};
